import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=78f632e6&"
import script from "./transactions.vue?vue&type=script&lang=js&"
export * from "./transactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f632e6')) {
      api.createRecord('78f632e6', component.options)
    } else {
      api.reload('78f632e6', component.options)
    }
    module.hot.accept("./transactions.vue?vue&type=template&id=78f632e6&", function () {
      api.rerender('78f632e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw_requests/tabs/transactions.vue"
export default component.exports